import { render, staticRenderFns } from "./error-monitor-error-list.component.vue?vue&type=template&id=c0218540&scoped=true&"
import script from "./error-monitor-error-list.component.vue?vue&type=script&lang=ts&"
export * from "./error-monitor-error-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./error-monitor-error-list.component.vue?vue&type=style&index=0&id=c0218540&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0218540",
  null
  
)

export default component.exports